const Divider = () => <div className='w-100 bg-gray-200' style={{ height: 1 }}></div>;

export default Divider;
